<div [style]="style" [class]="class"><ng-content></ng-content></div>
